import { render, staticRenderFns } from "./CertificateCards.vue?vue&type=template&id=f3b1bbee&"
import script from "./CertificateCards.vue?vue&type=script&lang=js&"
export * from "./CertificateCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports